export default (() => {
  class SearchForm {
    constructor ($searchForm, resultsSelector, filterSelector, applyFiltersSelector, activeFiltersTextSelector) {
      this.$form = $searchForm;
      this.$input = this.$form.find('[data-search-input]');
      this.$submitButton = this.$form.find('[data-search-button]');
      this.$resultsContainer = $(resultsSelector);
      this.$filterOptions = $(filterSelector);
      this.$applyFiltersButton = $(applyFiltersSelector);
      this.$activeFiltersTextContainer = $(activeFiltersTextSelector);
      this.filters = {};
    }

    getResults() {
      var self = this;
      var q = self.$input.val();

      self.$input.attr('disabled', true);
      self.$submitButton.attr('disabled', true);
      self.$applyFiltersButton.attr('disabled', true);

      var searchParams = {
        attributesToRetrieve: ['title', 'url', 'status', 'course__category', 'course__courseCode', 'course__accrdCourse'],
        hitsPerPage: 1000,
        page: 0
      };

      // Filter proccessing
      self.filters = {};

      self.$filterOptions.each(function() {
        if($(this).is(':checked') && $(this).val() != '') {
          var fieldHandle = $(this).attr('data-filter-field');
          var filterParam = $(this).attr('data-filter-param');
          if(self.filters.hasOwnProperty(fieldHandle)) {
            self.filters[fieldHandle].values.push($(this).val());
            self.filters[fieldHandle].labels.push($(this).attr('data-filter-label'));
          } else {
            self.filters[fieldHandle] = {
              param: filterParam,
              values: [$(this).val()],
              labels: [$(this).attr('data-filter-label')]
            };
          }
        }
      });

      var filterString = '(status:"live")';
      var paramsString = '?q=' + encodeURIComponent(q);
      var fieldHandles = Object.keys(self.filters);

      if(fieldHandles.length) {
        paramsString += '&';
        for(var i=0; i<fieldHandles.length; i++) {
          paramsString += self.filters[fieldHandles[i]].param + '=';
          var fieldString = '';
          for(var j=0; j<self.filters[fieldHandles[i]].values.length; j++) {
            fieldString += fieldHandles[i] + ':"' + self.filters[fieldHandles[i]].values[j] + '"';
            paramsString += encodeURIComponent(self.filters[fieldHandles[i]].values[j]);
            if(j < self.filters[fieldHandles[i]].values.length-1) {
              fieldString += ' OR ';
              paramsString += ','
            }
          }
          filterString += ' AND (' + fieldString + ')';
          if(i < fieldHandles.length-1) {
            // filterString += ' AND ';
            paramsString += '&';
          }
        }
      }

      if(filterString.length > 0) {
        searchParams.filters = filterString;
      }

      // Update URL params
      window.history.pushState({'all-courses': 'apply_filters'}, document.title, window.location.href.split('?')[0] + paramsString);

      // Scroll to results
      $('html, body').animate({ scrollTop: self.calculateCentreScreenOffset(self.$resultsContainer) });

      // Get Algolia results
      $.ajax({
        url: '/actions/algolia/default/search',
        cache: false,
        dataType: 'json',
        method: 'post',
        data: JSON.stringify({
          index: self.$input.attr('data-search-input'),
          query: q,
          params: searchParams
        }),
        success: function(response) {
          self.clearLoading();
          self.showResults(response);
        },
        error: function(response) {
          self.clearLoading();
          self.clearResults();
        }
      });
    }

    clearResults() {
      var self = this;
      self.$resultsContainer.empty();
    }

    showLoading() {
      var self = this;
      var $loadingOverlay = $('<div class="overlay d-flex justify-content-center align-items-center">\
          <div class="spinner-border text-primary m-3 spinner-grow-lg" role="status"></div>\
          <div>Loading results, please wait...</div>\
      </div>');
      self.$resultsContainer.append($loadingOverlay);
    }

    clearLoading() {
      var self = this;
      self.$input.removeAttr('disabled');
      self.$submitButton.removeAttr('disabled');
      self.$applyFiltersButton.removeAttr('disabled');
      self.$resultsContainer.find('.overlay').remove();
    }

    showResults(response) {
      var self = this;
      var results = {
        'Statement of Attainment': [],
        'Victorian Certificate': [],
        'Certificate 1': [],
        'Certificate 2': [],
        'Certificate 3': [],
        'Certificate 4': [],
        'Diploma': [],
        'Advanced Diploma': [],
        'Short Courses': []
      };

      var kioskMode = (typeof window.kioskMode !== 'undefined' && window.kioskMode == true) ? '?kiosk=1' : '';

      if(response.nbHits > 0) {

        for(var i=0; i<response.hits.length; i++) {
          var categories = response.hits[i].course__category;
          if(categories == null) {
            categories = ['Other'];
          }

          for(var j=0; j<categories.length; j++) {
            var category = categories[j];
            if(!results.hasOwnProperty(category)) {
              results[category] = [response.hits[i]];
            } else {
              results[category].push(response.hits[i]);
            }
          }
        }

        var categoryKeys = Object.keys(results);

        for(var i=0; i<categoryKeys.length; i++) {
          results[categoryKeys[i]] = results[categoryKeys[i]].sort(self.alphaCourses);
        }

        self.$resultsContainer.append('<h1 class="h4 mb-4">' + response.nbHits + ' course' + (response.nbHits > 1 ? 's' : '') + ' found:</h1>');

        for(var i=0; i<categoryKeys.length; i++) {
          if(results[categoryKeys[i]].length < 1) {
            continue;
          }
          var $categoryContainer = $('<div />').addClass('course-category-group mb-4');
          $categoryContainer.append('<h2 class="h4 mb-3">' + categoryKeys[i] + '</h2>');

          for(var j=0; j<results[categoryKeys[i]].length; j++) {
            var result = '\
            <div class="course-search-result mb-3">\
              <div class="course-search-result-title"><a href="' + results[categoryKeys[i]][j].url + kioskMode + '">' + results[categoryKeys[i]][j].title + (results[categoryKeys[i]][j].hasOwnProperty('course__courseCode') ? ' (' + results[categoryKeys[i]][j].course__courseCode + ')' : '') + '</a></div>'
                + (results[categoryKeys[i]][j].hasOwnProperty('course__accrdCourse') ? '<div class="accrd-course">from ' + results[categoryKeys[i]][j].course__accrdCourse + '</div>' : '') + '\
            </div>';

            $categoryContainer.append(result);
          }
          self.$resultsContainer.append($categoryContainer);
        }

      } else {
        self.clearResults();
        self.$resultsContainer.append('<h1 class="h4 mb-4">No courses found.</h1>');
      }
    }

    alphaCourses(a,b){
      return a.title.localeCompare(b.title);
    }

    renderActiveFilterText() {
      var self = this;

      var filterKeys = Object.keys(self.filters);
      self.$activeFiltersTextContainer.empty();

      if(filterKeys.length <= 0) {
        return;
      }

      var activeFiltersHtml = $('<div />').addClass('mb-3').html('<span class="font-weight-bold mr-2">Active filters:</span>');

      for(var i=0; i<filterKeys.length; i++) {
        for(var j=0; j<self.filters[filterKeys[i]].labels.length; j++) {
          var filterTag = $('<a />').attr('href', '#').attr('data-label',  self.filters[filterKeys[i]].labels[j]).addClass('all-course-filter mb-1 mr-1');
          filterTag.append('<div class="tag all-course-filter-tag px-2 py-1"><small>' + self.filters[filterKeys[i]].labels[j] + '</small></div>');
          filterTag.on('click', function(e) {
            self.handleFilterTagClick($(this), e);
          });
          activeFiltersHtml.append(filterTag);
        }
      }
      var clearFilters = $('<a />').attr('href', '#').addClass('clear-filters').html('<small>Clear all filters</small>');
      clearFilters.on('click', function(e) {
        self.handleClearFilterClick(e);
      });
      activeFiltersHtml.append(clearFilters);
      self.$activeFiltersTextContainer.html(activeFiltersHtml);
    }

    handleFilterTagClick($tag, e) {
      var self = this;

      var filterValue = $tag.attr('data-label');
      var $filterInput = $('input[data-filter-label="' + filterValue + '"]');
      $filterInput.prop('checked', false);

      $tag.remove();
      self.submitForm(e);
    }

    handleClearFilterClick(e) {
      var self = this;

      $('input[data-filter-field]').prop('checked', false);
      $('[data-filter-param="all"]').prop("checked", true);
      self.submitForm(e);
    }

    calculateCentreScreenOffset(el) {
      var elOffset = el.offset().top;
      var elHeight = el.height();
      var windowHeight = $(window).height();
      var offset;

      if(elHeight < windowHeight) {
        return elOffset - ((windowHeight / 2) - (elHeight / 2));
      } else {
        return elOffset;
      }
    }

    toggleSlide($trigger, $target, breakPoint) {
      var self = this;

      $trigger.one("click", $trigger.hasClass('open') ? showLess : showMore);
      function showMore() {
        if(breakPoint === undefined || !self.isBreakpoint(breakPoint)) {
          $target.slideDown(300);
          $target.removeClass('closed').addClass('open');
          $trigger.removeClass('closed').addClass('open');
        }
        $trigger.one("click", showLess);
      }
      function showLess() {
        if(breakPoint === undefined || !self.isBreakpoint(breakPoint)) {
          $target.slideUp(300);
          $target.removeClass('open').addClass('closed');
          $trigger.removeClass('open').addClass('closed');
        }
        $trigger.one("click", showMore);
      }
    }

    isBreakpoint(alias) {
        return $('.device-' + alias).is(':visible');
    }

    submitForm(e) {
      var self = this;

      e.preventDefault();
      self.clearResults();
      self.showLoading();
      self.getResults();
      self.renderActiveFilterText();
      return false;
    }

    init() {
      var self = this;

      // Search form submit
      self.$form.on('submit', function(e) {
        self.submitForm(e);
      });

      // Apply filters button
      self.$applyFiltersButton.on('click', function(e) {
        self.submitForm(e);
      });

      // Filter tags click
      $('.all-course-filter').on('click', function(e) {
        self.handleFilterTagClick($(this), e);
      });

      // Filter clear click
      $('.clear-filters').on('click', function(e) {
        self.handleClearFilterClick(e);
      });

      // Search input clear
      $('.js-search-reset').on('click', function(e) {
        self.$input.val('');
        self.submitForm(e);
      });

      // Filter options
      self.$filterOptions.on('change', function(e) {
        self.submitForm(e);
      });

      // Back button click
      $(window).on('popstate', function(e) {
        window.location.reload();
      });

      // Filters expand
      $('.filter-title').each(function() {
        self.toggleSlide($(this), $(this).next('.filter-list'));
      });

      // Filters sidebar expand (mobile only)
      $('.filters-cta').each(function() {
        self.toggleSlide($(this), $(this).next('.filter-groups'), 'lg');
      });

    }

  }

  $('[data-all-courses-form]').each(function () {

    const searchForm = new SearchForm($(this), '[data-search-results-container]', '[data-filter-param]', '[data-apply-filters]', '[data-active-filters-text]');
    searchForm.init();
  });

})()
